<template>
    <div class="vheader-menu">
        <!-- <div class="vheader-menu-item hide-on-tablet" id="old-interface-link">
            <a class="licexpert__text" :href="oldInterfaceLink" target="_blank">
                Перейти на
                <br>
                основной интерфейс
            </a>
        </div> -->
        <div class="vheader-menu-item vheader-menu-item-profile" @mouseover="showProfileMenu = true" @mouseleave="showProfileMenu = false">
            <span class="lnr lnr-user" v-if="userName"></span>
            <span v-if="userName" class="vheader-menu-item-profile__user-name">
                {{userName}}
            </span>
            <div v-else @click="showSignin">Войти</div>
            <div v-if="showProfileMenu && userName" class="vheader-menu-item-submenu">
                <div @click="redirect('/profile')"><a href="/profile">Профиль</a></div>
                <div @click="redirect('/signout')"><a href="/signout">Выход</a></div>
            </div>
        </div>
        <div class="vheader-menu-item vheader-menu-item-burger" @mouseover="showBurgerMenu = true" @mouseleave="showBurgerMenu = false">
            <i class="uk-icon-th uk-icon-small"></i>
            <div v-if="showBurgerMenu" class="vheader-menu-item-submenu vheader-menu-item-burger-submenu">
                <a v-router-link-fallback v-if="userName" href="/search">Подбор клиентов</a>
                <a v-router-link-fallback v-if="userName" href="/monitoring">
                    Мониторинг ЮЛ/ИП<i v-if="allCountUnseen" class="monitoring-notification">{{allCountUnseen}}</i>
                </a>
                <!-- <a v-router-link-fallback v-if="userName" href="/passport-check">Проверка паспорта</a> -->
                <a v-router-link-fallback v-if="userName" href="/monitoring-fl">Мониторинг сотрудников</a>
                <!-- <a v-router-link-fallback v-if="userName && checkFlAccess" href="/fl-check" class="new">Проверка ФЛ</a> -->
                <a v-router-link-fallback v-if="userName" href="/relations-search" class="beta">Поиск связей</a>
                <!-- <a v-router-link-fallback v-if="userName" href="/flat-check">Проверка квартиры</a> -->
                <!-- <a v-router-link-fallback v-if="userName" href="/egrn">Выписка ЕГРН</a> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showProfileMenu: false,
            showBurgerMenu: false
        }
    },
    methods: {
        showSignin() {
            UIkit.modal("#modal-signin").show()
        },
        signout(evt) {
            evt.preventDefault()
            this.$store.dispatch('user/signout')
        }
    },
    computed: {
        userName(){ return this.$store.state.userName },
        allCountUnseen() { return this.$store.getters['monitoring/allCountUnseen'] },
        checkFlAccess() { return this.$store?.state?.user?.user_data?.fl_online }
    }
}
</script>

<style lang="sass" scoped>
@use 'styles/mobile.sass'
@import 'styles/global-variables.sass'

$header-color: #005B9B

.new
    &:before
        content: 'new '
        color: $main-yellow
        padding: 0 !important

.beta
    &:before
        content: 'beta '
        color: $main-yellow
        padding: 0 !important

.vheader-menu
    display: inline-block
    font-size: 0
    a
        color: #fff
        text-decoration: none
        border: 0
        &:hover
            color: #fff
    &-item
        display: inline-block
        font-size: 16px
        font-weight: normal
        line-height: $header-height
        cursor: pointer
        padding: 0 20px
        text-align: center
        position: relative
        vertical-align: top
        &#old-interface-link
            line-height: 20px
            margin-top: 15px
            a:hover
                color: $main-yellow !important
        &-search
            font-variant: all-small-caps
            &:hover
                background-color: rgba(255,255,255,.3)
        &-profile
            &__user-name
                @media screen and (max-width: 850px)
                    display: none !important
            .lnr.lnr-user
                display: none
                height: $header-height
                line-height: $header-height
                @media screen and (max-width: 850px)
                    display: block
            &:hover
                color: $main-yellow
        &-submenu
            z-index: 3
            background-color: $header-color
            width: 100%
            right: 0
            position: absolute
            text-align: right
            color: #fff
            font-size: 14px
            min-width: 135px
            a
                font-weight: 400
                // height: $header-menu-height
                // line-height: $header-menu-height
                width: 100%
                display: block
                padding: 0 20px
                &:hover
                    background-color: rgba(255,255,255,.3)
                    color: #fff !important
        &-burger
            &:hover
                .uk-icon-th
                    color: $main-yellow
            &-submenu
                // width: 250px
                width: max-content
                i.monitoring-notification
                    display: inline-block
                    margin-left: 5px
                    border-radius: 12px
                    background-color: $main-yellow
                    height: 36px
                    line-height: 36px
                    padding: 0 10px
                    color: #333
                a
                    min-width: 250px
</style>
